export default __webpack_public_path__ + "static/media/FitsBasics.66cce420.jpg";